import styled from 'styled-components'

import { Dialog } from '@radix-ui/themes'

export const StyledContent = styled(Dialog.Content) <{
    $width: string
    $height?: string
}>`
    width: ${props => props.$width};
    height: ${props => props.$height};
    max-width: 100%;

    .rt-Heading {
        padding-bottom: 0;
    }
`
